/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Sword = [
  ["path", { d: "m11 19-6-6" }],
  ["path", { d: "m5 21-2-2" }],
  ["path", { d: "m8 16-4 4" }],
  ["path", { d: "M9.5 17.5 21 6V3h-3L6.5 14.5" }]
];

export { Sword as default };
//# sourceMappingURL=sword.js.map
